import { useQuery } from "@tanstack/react-query";
import { FetchProfileQueryParams, FetchProfilesResponse, fetchProfilesV2 } from "PFCore/services/profile";
import { QueryOptions } from "PFTypes/request_options";

import { profilesKeys } from "./query_keys";

export const useProfiles = (
  params: FetchProfileQueryParams,
  options: QueryOptions<FetchProfilesResponse> = {}
) => useQuery<FetchProfilesResponse>(profilesKeys.all(params), () => fetchProfilesV2(params), options);
